<script>
	import { fade } from 'svelte/transition'
	import { createDeck, shuffleDeck, scoreStack } from './deck'
	import Card from './Card.svelte'

	const STATES = {
		MENU: 'menu',
		PLAYING: 'playing',
		OUTCOME: 'outcome'
	}

	const TURNS = {
		PLAYER: 'player',
		TRANSITION: 'transition',
		DEALER: 'dealer'
	}

	const DEALER_DELAY = 1000;

	let state = STATES.MENU
	let turn = TURNS.PLAYER
	let deck = []
	let dealer = []
	let dealerScore = 0
	let player = []
	let playerScore = 0

	$: {
		playerScore = scoreStack(player)
		if (playerScore >= 21) {
			endPlayerTurn()
		}
	}

	$: dealerScore = scoreStack(dealer)
	$: playerScoreText = playerScore === 21 ? 'Blackjack' : playerScore > 21 ? 'Bust' : playerScore
	$: dealerScoreText = dealerScore === 21 ? 'Blackjack' : dealerScore > 21 ? 'Bust' : dealerScore

	function dealPlayer () {
		if (deck.length) player = [...player, deck.pop()]
	}

	function dealDealer () {
		if (deck.length) dealer = [...dealer, deck.pop()]
	}

	function initialDeal () {
		dealPlayer()
		dealDealer()
		dealPlayer()
		dealDealer()
	}

	function endPlayerTurn () {
		turn = TURNS.TRANSITION
		setTimeout(() => {
			turn = TURNS.DEALER
			setTimeout(() => {
				dealerTurn()
			}, DEALER_DELAY);
		}, 1000);
	}

	function endDealerTurn () {
		transitionOutcome()
	}

	function dealerTurn () {
		if (dealerScore >= 17 || playerScore > 21) {
			transitionOutcome()
			return
		}

		dealDealer()
		setTimeout(() => {
			dealerTurn()
		}, DEALER_DELAY)
	}

	function transitionPlay () {
		state = STATES.PLAYING
		turn = TURNS.PLAYER
		player = []
		dealer = []
		deck = shuffleDeck(createDeck())
		initialDeal()
	}

	function transitionOutcome () {
		state = STATES.OUTCOME
	}

	function transitionMenu () {
		state = STATES.MENU
	}

	function calculateOutcome () {
		if (playerScore > 21) {
			return 'Dealer wins'
		} else if (dealerScore > 21) {
			return 'You win!'
		} else if (playerScore === dealerScore) {
			return 'Tie!'
		} else if (playerScore > dealerScore) {
			return 'You win!'
		} else {
			return 'Dealer wins'
		}
	}
</script>

<main>
	{#if state === STATES.MENU}
		<div>
			<button on:click={transitionPlay}>Start new game</button>
		</div>
	{:else if state === STATES.PLAYING || state === STATES.OUTCOME}
		<div class="field-wrapper">
			{#if turn === TURNS.DEALER}
				<div class="fieldscore top" in:fade><span>{dealerScoreText}</span></div>
				<div class="field" in:fade>
					{#each dealer as card (card.suit + card.value)}
						<Card {card} show={turn === TURNS.DEALER} />
					{/each}
				</div>
				<div class="fieldsplit" in:fade></div>
			{/if}
			<div class="field">
				{#each player as card (card.suit + card.value)}
					<Card {card} show={true} />
				{/each}
			</div>
			<div class="fieldscore bottom"><span>{playerScoreText}</span></div>
		</div>
		{#if state === STATES.PLAYING && turn == TURNS.PLAYER}
			<div class="controls-play">
				<div>
					<button on:click={dealPlayer}>Hit</button>
					<button on:click={endPlayerTurn}>Stay</button>
				</div>
			</div>
		{/if}
		{#if state === STATES.OUTCOME}
			<div class="outcome-wrapper" in:fade>
				<div class="outcome">{calculateOutcome()}</div>
				<div>
					<button on:click={transitionPlay}>Play again</button>
					<button on:click={transitionMenu}>Main menu</button>
				</div>
			</div>
		{/if}
	{/if}
</main>

<style lang="scss">
	main {
		position: relative;
		width: 100%;
		height: 100%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		background: var(--to-table-color);
	}

	.field-wrapper {
		position: relative;
		width: 80vmin;
	}

	.field {
		display: flex;
		width: 100%;
		justify-content: space-evenly;
	}

	.fieldscore {
		width: 100%;
		height: 1rem;
		color: white;
		border-radius: 0 0 1vmin 1vmin;
		border: 2px solid rgba(255, 255, 255, 0.8);
		text-align: center;

		span {
			display: block;
			position: absolute;
			left: 50%;
			padding: 0 6px;
			text-align: center;
			background: var(--to-table-color);
			transform: translate(-50%, 0);
		}

		&.top {
			margin-top: 4vmin;
			border-radius: 1vmin 1vmin 0 0;
			border-bottom: none;
			span {
				bottom: 0.4rem;
			}
		}

		&.bottom {
			margin-bottom: 4vmin;
			border-radius: 0 0 1vmin 1vmin;
			border-top: none;
			span {
				top: 0.4rem;
			}
		}
	}

	.fieldsplit {
		width: calc(100% + 8vmin);
		margin: 4vmin -4vmin;
		border-top: 2px solid rgba(255, 255, 255, 0.6);
	}

	.outcome-wrapper {
		position: absolute;
		display: flex;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.6);
		align-items: center;
		justify-content: center;
		flex-direction: column;
		z-index: 10;

		.outcome {
			color: #ddd;
			text-shadow: 0 0 2p black;
			font-size: 2rem;
			margin-bottom: 2vmin;
		}
	}

	.controls-play {
		text-align: center;
	}
</style>